export const formatTimeTo12Hour = (timeString) => {
	const [hour, minute] = timeString.split(":");
	const hourInt = parseInt(hour, 10);
	const period = hourInt >= 12 ? "PM" : "AM";
	const formattedHour = hourInt % 12 || 12; // Converts 0 to 12 for midnight, and handles 12-hour conversion
	return `${formattedHour}:${minute} ${period}`;
};
